import React from "react"

type LogoIconProps = {
    width?: number
    height?: number
    size?: number // New size prop
}

const HamburgerLogo: React.FC<LogoIconProps> = ({ width, height, size }) => {
    const finalWidth = size || width || 47
    const finalHeight = size || height || 47

    return (
        <svg width={finalWidth} height={finalHeight} viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.1176 46.2353C35.8852 46.2353 46.2353 35.8852 46.2353 23.1176C46.2353 10.3501 35.8852 0 23.1176 0C10.3501 0 0 10.3501 0 23.1176C0 35.8852 10.3501 46.2353 23.1176 46.2353Z"
                fill="#00263A"
            />
            <path
                d="M32.7176 25.4082L11.6668 32.9054L12.7849 30.6741L31.9412 23.8525L23.1176 6.24706L8.96753 34.4824H12.324L23.1176 30.6388L33.9113 34.4824H37.2678L32.7176 25.4082ZM18.5626 26.8059L23.1176 17.6944L26.3019 24.0473L18.5626 26.8059ZM23.1176 10.0588L29.5504 22.8918L27.9212 23.4706L22.1633 11.9816L22.1428 12L23.1176 10.0588ZM22.1605 15.7871L16.2247 27.6353H16.2289L13.9066 28.4626L21.1991 13.8847L22.1605 15.7871ZM25.6645 29.7374L28.6221 28.6786L29.9089 31.2459L25.6645 29.7374ZM32.2292 32.076L30.2471 28.1005L31.8706 27.5224L34.5685 32.9054L32.2292 32.076Z"
                fill="white"
            />
        </svg>
    )
}

export default HamburgerLogo
